import { Routes } from '@angular/router';
import { gameInitializer } from './resolver/gameInitializer';
import { gameConfigs } from './config/game.config';

export const routes: Routes = [
  {
    // Gandalf is the default route
    path: gameConfigs.gandalf.urlBase,
    resolve: { gameInitializer },
    loadChildren: () => import('./routes/gandalf.routes').then((m) => m.gandalfRoutes),
  },
  {
    // Vision0 route
    path: gameConfigs.vision0.urlBase,
    resolve: { gameInitializer },
    loadChildren: () => import('./routes/vision0.routes').then((m) => m.vision0Routes),
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];
